import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 12,
    [theme.breakpoints.down("sm")]: {
      borderRadius: 0,
    },
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 2, 1),
    "& h2": {
      fontFamily: "Montserrat",
      fontWeight: 700,
      fontSize: 18,
    },
  },
  closeButton: {
    padding: 8,
  },
  dialogContent: {
    padding: theme.spacing(2, 3, 3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5, 2, 2),
    },
  },
  paper: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: theme.spacing(2),
    },
  },
  qrWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    borderRadius: 12,
    [theme.breakpoints.down("sm")]: {
      order: 1,
      alignSelf: "center",
      maxWidth: "100%",
    },
  },
  qrCanvas: {
    lineHeight: 0,
    "& canvas, & svg": {
      display: "block",
      maxWidth: "100%",
      height: "auto !important",
    },
  },
  instructions: {
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down("sm")]: {
      order: 2,
    },
  },
  titleDesktop: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: 20,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  step: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8125rem",
      lineHeight: 1.45,
    },
  },
  stepCompact: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      fontSize: "0.8125rem",
      lineHeight: 1.5,
      color: theme.palette.text.secondary,
    },
  },
  waiting: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    minWidth: 120,
  },
}))

export default useStyles
